'use client';

import { css } from '@bts-web/utils-style-engine';
import { ButtonBase } from '../../common';
import { StartSavingTranslationsKeys } from '../types';
import { StartSavingModal } from '../StartSavingModal/StartSavingModal';
import { useModalDrawerContext } from '../../common/components/ModalDrawerContext/ModalDrawerContext';
import { FilledArrowRight } from '../../common/svgIcons';

interface StartSavingButtonProps {
  className?: string;
  continueUrl: string;
  translations: StartSavingTranslationsKeys;
}

const StartSavingButton = ({
  className,
  continueUrl,
  translations,
}: StartSavingButtonProps) => {
  const { showModal } = useModalDrawerContext();

  const onClickStartSaving = () => {
    showModal(StartSavingModal, {
      continueUrl,
      disableOverlayClose: true,
    });
  };

  return (
    <ButtonBase
      className={className}
      noPadding
      visual="ghost"
      onClick={onClickStartSaving}
    >
      <span>{translations.savingsPlanStartSavingButton}</span>
      <FilledArrowRight
        className={css({ color: 'positive.fill_primary' })}
        size={16}
        data-dir="rtl"
      />
    </ButtonBase>
  );
};

export { StartSavingButton };
